/**
 * @name          jQuery Gallery Plugin
 * @version       1.0
 * @lastmodified  2016-02-21
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JR, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

(function($, window, document, undefined) {
  'use strict';

  var pluginName = 'gallerySwiper',
    defaults = {
      counterTemplate: '%curr% / %total%',
      previousTitle: 'Previous (Left arrow key)',
      nextTitle: 'Next (Right arrow key)',
      closeTitle: 'Close (Esc key)',
    },
    uid = 0;

  function Plugin(element, options) {
    this.$element = $(element);
    this.options = $.extend({}, defaults, options);
    this.init();
  }

  var methods = {
    init: function() {
      var self = this;
      var items = [];
      var $lightboxToggle = self.$element.find('.slider__openLightbox');

      // get unique cache key for popup
      var key = 'gallery-' + uid++;

      self.$element.find('.slider__content li').each(function() {
        var $figure = $(this)
          .find('.figure')
          .clone();

        if ($(this).find('.slider__caption')) {
          var $caption = $(this)
            .find('.slider__caption')
            .clone();
          $caption.append($('<i class="mfp-infoToggle-overlay"></i>'));
          $caption.addClass('hidden').addClass('test');
          $figure.append($caption);
        }

        $figure.find('.picture').attr('data-container', '.mfp-content');

        items.push({
          item: $figure,
        });
      });

      self.$element.on(
        'click',
        '.slider__openLightbox, .slider__content .figure',
        function(e) {
          e.preventDefault();

          var sliderInstance = self.$element.data('plugin_swiperSlider').slider;

          $.magnificPopup.open(
            {
              key: key,
              delegate: 'a',
              items: items.slice(0),
              gallery: {
                enabled: true,
                tCounter: self.options.counterTemplate,
                tPrev: self.options.previousTitle,
                tNext: self.options.nextTitle,
              },
              type: 'inline',
              inline: {
                // Define markup. Class names should match key names.
                markup: global.configuration.data.tpl.magnificPopupInline(),
              },
              fixedContentPos: true,
              closeOnBgClick: false,
              closeBtnInside: false,
              closeMarkup:
                '<button title="' +
                self.options.closeTitle +
                '" type="button" class="mfp-close"></button>',
              callbacks: {
                open: function() {
                  var content = this;

                  content.content.find('.slider__caption').addClass('hidden');

                  self.loadResponsiveImage(this.content);

                  // set body class to reset e.g. fixed header...
                  $('body').addClass('mfp-lightboxActive');

                  this.content.closest('.mfp-container').addClass('showInfo');

                  this.content.on(
                    'click',
                    '.mfp-infoToggle-overlay',
                    function() {
                      e.preventDefault();
                      $(this)
                        .closest('.mfp-container')
                        .toggleClass('showInfo');
                    }
                  );

                  $(window).trigger('resize');

                  var mc = new Hammer(this.content.get(0), {
                    recognizers: [
                      [
                        Hammer.Swipe,
                        {
                          direction: Hammer.DIRECTION_HORIZONTAL,
                        },
                      ],
                    ],
                  });

                  /*Fix caption width*/
                  setTimeout(function() {
                    content.content
                      .find('img')
                      .one('load', function() {
                        content.content.find('.slider__caption').css({
                          width: content.content.find('img').width(),
                        });

                        content.content
                          .find('.slider__caption')
                          .removeClass('hidden');
                      })
                      .each(function() {
                        if (this.complete) {
                          $(this).load();
                        }
                      });

                    $(window).on('resize', function() {
                      if (content.content) {
                        content.content.find('.slider__caption').css({
                          width: content.content.find('img').width(),
                        });
                      }
                    });
                  });

                  // swipe debounced
                  mc.on('swipe', function(e) {
                    clearTimeout(self.swipeDebounce);
                    self.swipeDebounce = setTimeout(function() {
                      if (e.direction === Hammer.DIRECTION_LEFT) {
                        $.magnificPopup.instance.next();
                      } else if (e.direction === Hammer.DIRECTION_RIGHT) {
                        $.magnificPopup.instance.prev();
                      }
                    }, 150);
                  });
                },
                close: function() {
                  // remove info toggle listener
                  this.content.find('.mfp-infoToggle').off('click.infoToggle');

                  // remove lightbox active class from body
                  $('body').removeClass('mfp-lightboxActive');
                },
                afterChange: function() {
                  var content = this;
                  self.loadResponsiveImage(this.content);

                  content.content
                    .find('img')
                    .one('load', function() {
                      content.content.find('.slider__caption').css({
                        width: content.content.find('img').width(),
                      });

                      content.content
                        .find('.slider__caption')
                        .removeClass('hidden');
                    })
                    .each(function() {
                      if (this.complete) {
                        $(this).load();
                      }
                    });

                  $(window).on('resize', function() {
                    if (content.content) {
                      content.content.find('.slider__caption').css({
                        width: content.content.find('img').width(),
                      });
                    }
                  });
                },
              },
            },
            sliderInstance.realIndex
          );
        }
      );
    },

    loadResponsiveImage: function($item) {
      var $picture = $item.find('.picture');
      if (!$picture.is(':visible')) {
        return;
      }

      if ($picture.data('plugin_responsiveImage')) {
        $picture.data('plugin_responsiveImage').loadResponsiveImage();
      } else {
        $picture.responsiveImage({
          attributes: ['loading', 'title', 'alt', 'class', 'width', 'height'],
          autoDpr: true,
          onGetWidth: function() {
            return (
              window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth
            );
          },
        });
      }
    },
  };

  $.extend(Plugin.prototype, methods);

  $.fn[pluginName] = function(options) {
    this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
      }
    });

    return this;
  };
})(jQuery, window, document);
